import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import TabelaAtivos from './TabelaAtivos';
import DetalheAtivo from './DetalheAtivo';

const RelatorioFilaLote = () => {
  const [dadosAtivos, setDadosAtivos] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [opcoesEmpreendimentos, setOpcoesEmpreendimentos] = useState([]);
  const [opcoesCorretores, setOpcoesCorretores] = useState([]);
  const [ativoSelecionado, setAtivoSelecionado] = useState(null);
  const [dadosDetalhe, setDadosDetalhe] = useState(null);
  const [isLoadingDetalhe, setIsLoadingDetalhe] = useState(false);
  const [nomeEmpreendimento, setNomeEmpreendimento] = useState(null);

  useEffect(() => {
    const carregarOpcoes = async () => {
      try {
        const [emps, cors] = await Promise.all([
          api.obterEmpreendimentosFilaLote(),
          api.BuscarCorretores(),
        ]);
        setOpcoesEmpreendimentos(emps);
        setOpcoesCorretores(cors);
      } catch (err) {
        toast.error('Erro ao carregar opcoes.');
      }
    };
    carregarOpcoes();
  }, []);

  const handleSubmit = async values => {
    if (!values.codigo_empreendimento && !values.quadra && !values.lote && !values.codigo_corretor) {
      toast.error('Informe ao menos um filtro para a busca.');
      return;
    }

    setIsLoading(true);
    setDadosAtivos(null);
    setAtivoSelecionado(null);
    setDadosDetalhe(null);

    try {
      const filtros = {
        codigo_empreendimento: values.codigo_empreendimento || null,
        quadra: values.quadra || null,
        lote: values.lote || null,
        codigo_corretor: values.codigo_corretor || null,
      };

      const response = await api.consultarFilaLote(filtros);

      if (!response || response.length === 0) {
        toast.warning('Nenhum registro encontrado para os filtros informado.');
        return;
      }

      setDadosAtivos(response);
      setNomeEmpreendimento(values.nome_empreendimento || '');
    } catch (err) {
      toast.error(err.message || 'Erro ao consultar fila do lote.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDetalhar = async ativo => {
    setIsLoadingDetalhe(true);
    setAtivoSelecionado(ativo);
    setDadosDetalhe(null);

    try {
      const response = await api.obterDetalheAtivoFilaLote({ codigo_ativo: ativo.codigo_ativo });
      setDadosDetalhe(response);
    } catch (err) {
      toast.error(err.message || 'Erro ao carregar detalhe do ativo.');
    } finally {
      setIsLoadingDetalhe(false);
    }
  };

  const handleVoltar = () => {
    setAtivoSelecionado(null);
    setDadosDetalhe(null);
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Filas do lote" />

      {!ativoSelecionado && (
        <FiltrosRelatorio
          onSubmit={handleSubmit}
          isLoading={isLoading}
          opcoesEmpreendimentos={opcoesEmpreendimentos}
          opcoesCorretores={opcoesCorretores}
        />
      )}

      {isLoading && <Loading label="Carregando ativos" />}

      {dadosAtivos && !ativoSelecionado && (
        <TabelaAtivos
          dados={dadosAtivos}
          nomeEmpreendimento={nomeEmpreendimento}
          onDetalhar={handleDetalhar}
        />
      )}

      {ativoSelecionado && (
        <DetalheAtivo
          ativo={ativoSelecionado}
          dados={dadosDetalhe}
          isLoading={isLoadingDetalhe}
          onVoltar={handleVoltar}
        />
      )}
    </Container>
  );
};

export default RelatorioFilaLote;
